module.exports = __webpack_public_path__ + "static/media/logo3.2c209e55.png";